/**
 * Проверяет, является ли массив пустым, null или undefined.
 *
 * @param {Array | null | undefined} array - Массив для проверки.
 * @returns {boolean} - true, если массив пустой, null или undefined, иначе false.
 */
export const arrayIsEmpty = <T>(array: T[] | null | undefined): array is null | undefined => {
    if (typeof array !== "object" || array == null || array.length === 0) {
        return true;
    }

    return false;
};
